import { Component, EventEmitter, OnInit, Output , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { State } from '@app/core/ngrx/reducers';
import { paymentSelectors } from '@app/core/ngrx/selectors';
import { FormService } from '@app/core/services/form/form.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { Store } from '@ngrx/store';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-payment-billing-inputs',
    templateUrl: './payment-billing-inputs.component.html',
    styleUrls: ['./payment-billing-inputs.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class PaymentBillingInputsComponent implements OnInit {
    constructor(
        private formService: FormService,
        private store: Store<State>,
        public toolService: ToolService
    ) {
        this.valueChanged();
    }

    @Output() valueChange = new EventEmitter();

    payment_form: FormGroup;
    countries = [];
    content: any;
    validNumber = true;

    countryAlert = {
        cssClass: 'stripe-month-alert',
    };

    paymentForm_subscription = this.formService
        .paymentForm() // get the payment form
        .subscribe((form: FormGroup) => (this.payment_form = form));

    trackByIndex = (index: number): number => index;

    ngOnInit() {/* empty */}

    submit() {/* empty */}

    valueChanged() {
        // You can give any function name
        this.payment_form.valueChanges.subscribe((changes: any) => {
            this.valueChange.emit(this.payment_form);
        });
    }
}
